import CloseIcon from '@mui/icons-material/Close';
import { Box, IconButton, Typography, alpha, useTheme } from '@mui/material';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { glb_sv } from 'src/utils';

const ItemAdd = memo(({ p, handleRemoveProduct }) => {
    const { t } = useTranslation();
    const theme = useTheme();

    // Kiểm tra trạng thái available
    const isUnavailable = p.available === false;

    // Lấy URL ảnh
    const imageUrl = p?.img_device
        ? glb_sv.urlGetProductImage(p?.img_device)
        : glb_sv.urlGetProductImage(p?.pic_device);

    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1.5,
                p: 1.5,
                mb: 1, // Khoảng cách giữa các item
                borderRadius: 2,
                bgcolor: isUnavailable
                    ? alpha(theme.palette.action.disabledBackground, 0.5) // Màu nền xám nhạt nếu ko có sẵn
                    : 'background.paper', // Màu nền trắng/sáng nếu ok
                border: '1px solid',
                borderColor: isUnavailable ? 'transparent' : 'divider',
                boxShadow: isUnavailable ? 'none' : theme.shadows[1],
                opacity: isUnavailable ? 0.7 : 1, // Làm mờ nhẹ cả khối
                transition: 'all 0.2s ease-in-out',
                '&:hover': {
                    bgcolor: isUnavailable ? undefined : alpha(theme.palette.primary.main, 0.04),
                    borderColor: isUnavailable ? undefined : 'primary.main',
                },
                position: 'relative',
                overflow: 'hidden',
            }}
        >
            {/* Hình ảnh sản phẩm */}
            <Box
                component="img"
                src={imageUrl}
                alt={p.device_nm}
                sx={{
                    width: 48,
                    height: 48,
                    borderRadius: 1.5,
                    objectFit: 'cover',
                    // Nếu không có sẵn thì chuyển ảnh sang trắng đen
                    filter: isUnavailable ? 'grayscale(100%)' : 'none',
                    border: '1px solid',
                    borderColor: 'divider',
                }}
            />

            {/* Thông tin sản phẩm */}
            <Box sx={{ flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                <Typography
                    variant="body2"
                    fontWeight={600}
                    noWrap
                    title={p.device_nm}
                    sx={{
                        textDecoration: isUnavailable ? 'line-through' : 'none',
                        color: isUnavailable ? 'text.disabled' : 'text.primary',
                    }}
                >
                    {p.device_nm}
                </Typography>

                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Typography
                        variant="caption"
                        sx={{
                            bgcolor: 'primary.main',
                            color: 'white',
                            px: 0.8,
                            py: 0.2,
                            borderRadius: 1,
                            fontWeight: 'bold',
                            filter: isUnavailable ? 'grayscale(100%)' : 'none',
                        }}
                    >
                        x{p.quantity}
                    </Typography>

                    <Typography
                        variant="caption"
                        color="text.secondary"
                        sx={{
                            textDecoration: isUnavailable ? 'line-through' : 'none',
                        }}
                    >
                        {t(p.bussiness === 'etk' ? 'getting_device' : 'rorrowing_device')}
                    </Typography>
                </Box>

                <Typography
                    variant="caption"
                    fontWeight={400}
                    noWrap
                    title={p.device_nm}
                    sx={{
                        textDecoration: isUnavailable ? 'line-through' : 'none',
                        color: isUnavailable ? 'text.disabled' : 'text.primary',
                    }}
                >
                    {p.device_cd}
                </Typography>
            </Box>
            <Box display={'flex'} flexDirection={'column'}>
                <Typography variant="subtitle2" noWrap sx={{ fontWeight: '600' }}>
                    {t('cabinet')}: {p.cabinet_nm}
                </Typography>{' '}
                <Typography variant="subtitle2" noWrap>
                    {t('drawer')}: {p.drawer_nm}
                </Typography>{' '}
                <Typography variant="subtitle2" noWrap>
                    {t('cell')}: {`[ ${p?.cell_lc?.row} : ${p?.cell_lc?.column} ]`}
                </Typography>
            </Box>
            {/* Nút xóa */}
            <IconButton
                size="small"
                onClick={() => handleRemoveProduct(p.device_id)}
                sx={{
                    color: 'text.secondary',
                    '&:hover': {
                        color: 'error.main',
                        bgcolor: alpha(theme.palette.error.main, 0.1),
                    },
                }}
            >
                <CloseIcon fontSize="small" />
            </IconButton>
        </Box>
    );
});

export default ItemAdd;
